import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-2 order-md-1" }
const _hoisted_2 = { class: "fw-bold me-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  javascript: "void(0)",
  class: "copyright-text"
}, " Caffeine", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "footer py-4 d-flex flex-lg-column",
    style: { background: _ctx.footer_bg_color, color: _ctx.footer_color },
    id: "kt_footer"
  }, [
    _createVNode("div", {
      class: ["d-flex flex-column flex-md-row align-items-center justify-content-between", {
                'container-fluid': _ctx.footerWidthFluid,
                container: !_ctx.footerWidthFluid
            }]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, _toDisplayString(new Date().getFullYear()) + "©", 1),
        _hoisted_3,
        _createTextVNode(". " + _toDisplayString(_ctx.$t('message.ALL_RIGHTS_RESERVED')), 1)
      ])
    ], 2)
  ], 4))
}